/*
 * Cart drawer extras
 * 1) Related products panel: fetches Shopify product recommendations based on
 *    the most recently added cart item and refreshes on every cart change.
 * 2) "Continue shopping" button: closes the cart drawer.
 */
(function () {
  'use strict';

  var PANEL_SELECTOR = '[data-cart-related]';
  var CONTENT_SELECTOR = '[data-cart-related-content]';
  var ITEM_SELECTOR = '.cart__item[data-product-id]';
  var CONTINUE_SELECTOR = '[data-cart-continue-close]';

  function getPanels() {
    return document.querySelectorAll(PANEL_SELECTOR);
  }

  // Most recently added product = last line item in the cart.
  function getBaseProductId() {
    var items = document.querySelectorAll(ITEM_SELECTOR);
    if (!items.length) return null;
    return items[items.length - 1].getAttribute('data-product-id');
  }

  function shopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function fetchRelated(panel) {
    var content = panel.querySelector(CONTENT_SELECTOR);
    var id = getBaseProductId();

    if (!id) {
      panel.classList.remove('is-populated');
      panel.__lastId = null;
      if (content) content.innerHTML = '';
      return;
    }

    // Skip refetch if base product is unchanged and we already have results.
    if (panel.__lastId === id && panel.classList.contains('is-populated')) return;
    panel.__lastId = id;

    var limit = panel.getAttribute('data-limit') || '4';
    var sectionId = panel.getAttribute('data-section') || 'api-cart-recommendations';
    var intent = panel.getAttribute('data-intent') || 'related';
    var url =
      shopRoot() +
      'recommendations/products?section_id=' + encodeURIComponent(sectionId) +
      '&intent=' + encodeURIComponent(intent) +
      '&limit=' + encodeURIComponent(limit) +
      '&product_id=' + encodeURIComponent(id);

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var holder = doc.querySelector('[data-api-related-content]');
        var markup = holder ? holder.innerHTML.trim() : '';

        if (content) content.innerHTML = markup;
        panel.classList.toggle('is-populated', markup.length > 0);
      })
      .catch(function () {
        panel.__lastId = null;
      });
  }

  function refreshAll() {
    var panels = getPanels();
    for (var i = 0; i < panels.length; i++) fetchRelated(panels[i]);
  }

  var refreshTimer;
  function debouncedRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshAll, 150);
  }

  function observeCart() {
    var holder = document.querySelector('[data-items-holder]');
    if (!holder || holder.__relatedObserved) return;
    holder.__relatedObserved = true;
    new MutationObserver(debouncedRefresh).observe(holder, {childList: true, subtree: true});
  }

  function bindContinue() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest(CONTINUE_SELECTOR) : null;
      if (!btn) return;
      e.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      var closeBtn = drawer && drawer.querySelector('[data-cart-drawer-close]');
      if (closeBtn) closeBtn.click();
    });
  }

  function init() {
    bindContinue();

    if (getPanels().length) {
      observeCart();
      document.addEventListener('theme:cart-drawer:open', debouncedRefresh);
      debouncedRefresh();
    }
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
